import './admin-reimpersonate'
import setupFirmFilterer from './firm-filterer'
import setupAmlFilterer from './aml-filterer'
import getAdapter from '@app/adapters/$get'
import select2Adapter from '@app/adapters/select2'

onDomLoad(function ($dom) {
  const unsubscribe = setupFirmFilterer($dom, {
    get: getAdapter,
    select2: select2Adapter,
  })

  const unsubscribeAml = setupAmlFilterer($dom, {
    get: getAdapter,
    select2: select2Adapter,
  })

  $dom.one('turbolinks:before-visit', () => {
    unsubscribe()
    unsubscribeAml()
  })
})
